import { render, staticRenderFns } from "./ChangeKidsDialog.vue?vue&type=template&id=b96679ea&scoped=true"
import script from "./ChangeKidsDialog.vue?vue&type=script&lang=js"
export * from "./ChangeKidsDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeKidsDialog.vue?vue&type=style&index=0&id=b96679ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96679ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b96679ea')) {
      api.createRecord('b96679ea', component.options)
    } else {
      api.reload('b96679ea', component.options)
    }
    module.hot.accept("./ChangeKidsDialog.vue?vue&type=template&id=b96679ea&scoped=true", function () {
      api.rerender('b96679ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mauser/ChangeKidsDialog.vue"
export default component.exports